const actions = {
    async postcodeLookup({}, address): Promise<any> {
        const { data } = await this.$solarClient.get(`/api/address/autocomplete/details/${address['postcode']}/${address['houseNr']}/${address['houseNrAdd'] ?? ''}`);

        return data;
    },
};


const Address = {
    namespaced: true,
    actions,
};

export default Address;
